import type { UserSubscriptionDTO } from './subscription.dto';
import type { SubscriptionStatus, UserSubscription } from '../types';

const STATUS_MAP: Record<string, SubscriptionStatus> = {
  active: 'active',
  trialing: 'trialing',
  trial: 'trialing',
  canceled: 'canceled',
  cancelled: 'canceled',
  expired: 'expired',
};

/** Adapter: API subscription DTO -> domain `UserSubscription`. */
export class SubscriptionMapper {
  toDomain(dto: UserSubscriptionDTO): UserSubscription {
    return {
      id: dto.id,
      bundle: dto.bundle,
      planCode: dto.plan_code,
      status: STATUS_MAP[dto.status?.toLowerCase?.()] ?? 'unknown',
      isMainPlan: Boolean(dto.main_plan),
      startedAt: dto.started_at,
    };
  }

  toDomainList(dtos: UserSubscriptionDTO[]): UserSubscription[] {
    return dtos.map((dto) => this.toDomain(dto));
  }
}

export const subscriptionMapper = new SubscriptionMapper();
